module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/twitter-black-275af6cca0ccddcd71d47ae273269ac8.svg";